import { Injectable } from '@angular/core';
import { API_V1_AUTH } from '@core/config/app';
import { AuthRequest, AuthResponse } from '@core/interfaces/auth/auth';
import { User } from '@core/interfaces/auth/user';
import { CommonService } from './common-service.service';
import { Observable, map } from 'rxjs';

const authKey: string = 'kardexpro_auth';

@Injectable({
  providedIn: 'root'
})
export class AuthService extends CommonService<User> {

protected override endpoint: string = API_V1_AUTH;

  private _auth?: AuthResponse;

  constructor() {
    super();
    const authString = localStorage.getItem(authKey);
    if (authString) {
      this._auth = JSON.parse(authString);
    }
  }

  public authenticate(authRequest: AuthRequest): Observable<User> {
    return this.http.post<AuthResponse>(`${this.endpoint}/authenticate`, authRequest)
      .pipe(
        map(response => {
          localStorage.setItem(authKey, JSON.stringify(response));
          this._auth = response;
          return response.user;
        })
      );
  }

  get user(): User | undefined {
    return this._auth?.user;
  }

  get token(): string | undefined {
    return this._auth?.token;
  }

  logout() {
    localStorage.removeItem(authKey);
    this._auth = undefined;
  }

  isAuthenticated(): boolean{
    if (!this._auth) return false;
    let payload = this.getDataTokem(this.token!);
    if(payload && payload.sub && payload.sub.length > 0){
      return true;
    }
    return false;
  }

  isTokenExpired(): boolean{
    if (!this._auth) return false;
    let token = this._auth.token;
    let payload = this.getDataTokem(token);
    // De esta forma estamos obteniendo la fecha en milisegundos
    let now = new Date().getTime()/1000;

    if(payload.exp < now){
      return true;
    }
    return false;
  }

  getDataTokem(accessToken: string): any{
    if(accessToken != null){
      return JSON.parse(atob(accessToken.split(".")[1]));
    }
    return null;
  }

}
